// @givmo/board — text whose number ranges stay on one line: an agenda item's description, and a
// committee decision's line on its page (CBG-YR6-CONFIRM).
//
// A line may break after an en dash (UAX #14's LB12a), so a tally ("Carried 3–0", or the "(Carried
// 3–0)" the backend writes into an item added from a committee's decisions) could end one line with
// "3–" and start the next with "0)". Each run of digits joined by an en dash is drawn unbroken, in a
// `whitespace-nowrap` span (CBG-FIX92's idiom for a tally printed inline); nothing is added to the
// text, so what a reader copies is what was stored.

import type { ReactNode } from 'react';

const RANGE = /\d+–\d+/g;

export function keepRangesTogether(text: string): ReactNode[] {
  const parts: ReactNode[] = [];
  let from = 0;
  for (const match of text.matchAll(RANGE)) {
    const at = match.index;
    if (at > from) parts.push(text.slice(from, at));
    parts.push(
      <span key={at} className="whitespace-nowrap">
        {match[0]}
      </span>,
    );
    from = at + match[0].length;
  }
  if (from < text.length) parts.push(text.slice(from));
  return parts;
}
